<script lang="ts" setup>
import { createBase64Image, resizeImage } from "@/FileHelper";
import Constants from "../Constants";
import { Capacitor } from "@capacitor/core";
import AUApi from "@/api";
import { Globals } from "@/Globals";
import { globalsBezeichnung } from "@/local";
import { onMounted, reactive, ref } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "./EditComponentStatic";
import { useRegisterValidation } from '@/components/EditorValidator';

const emitFn = defineEmits<CommonEditControlEmits>();

const props = defineProps<EditControlProps>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);

config.validate = validate;
useRegisterValidation({ config });


let imageName: string = "";
let imageFile: File | null = null;
let loading: boolean = false;
let base64data = ref("");

onMounted(() => {
  mounted(uiData, props, config);
  const x: {
    name: string | null;
    data: string | null;
    type: string | null;
  } = config.initValue;

  if (x?.data) {
    // bei pdf nicht laden!
    if (x.type !== "application/pdf") {
      base64data.value = x.data;
    }
  }
  if (x?.name) {
    imageName = x.name;
    if (!base64data) {
      loadImage(x);
    }
  }
});

function loadImage(image: any) {
  if (image.datentyp === "Doku") {
    base64data.value = AUApi.Current.fullUrl(
      "pdf2/" + AUApi.Current.user.id + ":" + +image.aic + "_" + image.name
    );
  } else {
    base64data.value = AUApi.Current.fullUrl(
      "image2/" + AUApi.Current.user.id + ":" + +image.aic + "_" + image.name
    );
  }
}
async function fileChanged() {
  const file = imageFile as File;
  if (file !== undefined) {
    imageName = file.name;
    if (imageName.lastIndexOf(".") <= 0) {
      return;
    }
    try {
      let thumbnail;
      if (Constants.isMobile && Capacitor.getPlatform() !== "android") {
        thumbnail = await resizeImage(file, 1100, 1100);
        // wenn IOS dann nicht so stark komprimieren!
      } else {
        thumbnail = await resizeImage(file, 1000, 1000);
      }
      const base64 = await createBase64Image(thumbnail);
      base64data.value = base64;
      valueChanged(config, uiData, { data: base64, name: file.name });
    } catch (error) {
      loading = false;
      console.log("error reading File:" + error);
      alert("Kann File leider nicht lesen!");
      imageFile = null;
    }
  }
}

function validate() {
  if (uiData.required) {
    if (imageName) {
      uiData.errorText = "";
      return true;
    }
    uiData.errorText = config.requiredMessage;
    return false;
  }

  return true;
}
</script>
<template>
  <div class="wrap" v-if="uiData.showMutable">
    <v-tooltip :disabled="!uiData.showtooltip || !uiData.tooltip" location="bottom" max-width="300px"
      :text="uiData.tooltip">
      <template v-slot:activator="{ props }">
        <v-file-input v-bind="props" id="image" ref="image" :label="globalsBezeichnung(
          Globals.Begriff,
          'Web_Datei_Auswahl',
          'Datei Auswahl'
        )
          " variant="outlined" density="compact" prepend-icon="mdi-camera" accept="image/*,.pdf"
          :placeholder="imageName" :disabled="uiData.disabled" v-model="imageFile" :loading="loading"
          @change="fileChanged" show-size type="file" :error-messages="uiData.errorText" :required="uiData.required"
          color="warning" persistent-hint></v-file-input>

        <div v-if="imageName">{{ imageName }}</div>
        <v-img v-if="base64data" :src="base64data" style="max-width: 150px; max-height: 150px" />
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </template>
    </v-tooltip>
  </div>
</template>
